import { ASSIGNED_STATUS, ASSIGNED_TYPE } from '@vindr/services/constants/assigned.constant';
import { formatDateColumn } from '@vindr/utils/dateTime';
import { TableColumnsType } from 'antd';
import { useTranslation } from 'react-i18next';
import ActionIcon from '../../ui/ActionIcon/ActionIcon';

const useAssignedColumns = ({ onRemove, onEdit }): TableColumnsType<any> => {
  const { t } = useTranslation('Vindoc');

  return [
    {
      title: '#',
      width: 40,
      dataIndex: 'id',
      key: 'id',
      ellipsis: true,
      render: (_, __, index) => index + 1,
    },
    {
      title: t('Assign Type'),
      width: 100,
      dataIndex: 'type',
      key: 'type',
      ellipsis: true,
      // sorter: sorter,
      render: (type) => ASSIGNED_TYPE[type],
    },
    {
      title: t('Status'),
      width: 100,
      dataIndex: 'status',
      key: 'status',
      ellipsis: true,
      // sorter: sorter,
      render: (status) => ASSIGNED_STATUS[status],
    },
    {
      title: t('Assigned To'),
      dataIndex: 'assign_to',
      key: 'assign_to',
      width: 140,
      ellipsis: true,
      render: (_, record) =>
        record?.type === ASSIGNED_TYPE.USER
          ? (record?.assign_users || []).map((it) => it?.fullname).join(', ')
          : (record?.assign_groups || []).map((it) => it?.name).join(', '),
    },
    {
      title: t('Assigned At'),
      dataIndex: 'created_at',
      key: 'created_at',
      width: 140,
      // sorter: true,
      ellipsis: true,
      render: (date) => formatDateColumn(date),
    },
    {
      title: t('Actions'),
      dataIndex: 'operation',
      key: 'operation',
      align: 'center',
      width: 80,
      fixed: 'right',
      render: (text, record) => {
        return (
          <ActionIcon>
            <ActionIcon.Edit
              onClick={() => onEdit(record)}
              // disabled={!keycloak.hasOneOfPerm([PERMISSIONS.order.update])}
            />
            <ActionIcon.Delete
              onClick={() => onRemove(record)}
              // disabled={!keycloak.hasOneOfPerm([PERMISSIONS.order.delete])}
            />
          </ActionIcon>
        );
      },
    },
  ];
};

export default useAssignedColumns;
